import router from '@/router';
import store from '@/store';

export class AuthExpiredError extends Error {
    constructor(message = 'Session expired') {
        super(message);
        this.name = 'AuthExpiredError';
    }
}

let handlingUnauthorized = false;

function isSameRouteTarget(target) {
    const currentRoute = router.currentRoute;
    if (!currentRoute) {
        return false;
    }

    const resolvedTarget = router.resolve(target).route;
    return resolvedTarget.fullPath === currentRoute.fullPath;
}

export async function clearCourseCaches() {
    if (typeof caches === 'undefined') {
        return;
    }

    try {
        const cacheNames = await caches.keys();
        await Promise.all(cacheNames.map(async (cacheName) => {
            if (cacheName.startsWith('course')) {
                return caches.delete(cacheName);
            }
            return null;
        }));
    } catch {
        // Cache cleanup must not prevent logout, session expiry, or a new login.
    }
}

export async function logoutToLogin(query = {}) {
    store.dispatch('setMaintenanceMode', [false]);
    store.dispatch('logout');
    await clearCourseCaches();
    await navigateToLogin(query);
}

export async function requireAuthenticatedSession(message = 'Session expired') {
    const token = store.getters.getToken;

    if (token) {
        return token;
    }

    await navigateToLogin();
    throw new AuthExpiredError(message);
}

export async function handleUnauthorized(message) {
    if (!handlingUnauthorized) {
        handlingUnauthorized = true;

        const currentRoute = router.currentRoute;
        const nextQuery = {
            ...(currentRoute && currentRoute.query ? currentRoute.query : {}),
            expired: '1',
        };
        await logoutToLogin(nextQuery);

        setTimeout(() => {
            handlingUnauthorized = false;
        }, 0);
    }

    return new AuthExpiredError(message);
}

export function isAuthExpiredError(error) {
    return error instanceof AuthExpiredError || error?.name === 'AuthExpiredError';
}

export function navigateToLogin(query = {}) {
    const loginTarget = {
        path: '/login',
        query,
    };

    if (isSameRouteTarget(loginTarget)) {
        return Promise.resolve();
    }

    return router.push(loginTarget).catch(() => {});
}
